export const theme = {
  container: 'mos-catalog-search__container',
  containerOpen: 'mos-catalog-search__container_open',
  input: 'mos-catalog-search-input',
  inputOpen: 'mos-catalog-search-input--open',
  inputFocused: 'mos-catalog-search-input--focused',
  suggestionsContainer: 'mos-catalog-search__suggestions-container',
  suggestionsContainerOpen: 'mos-catalog-search__suggestions-container--open',
  suggestionsList: 'mos-catalog-search__suggestions-list',
  suggestion: 'mos-catalog-search-suggestion__container',
  suggestionFirst: 'mos-catalog-search-suggestion--first',
  suggestionHighlighted:
    'mos-catalog-search-suggestion__container--highlighted',
  suggestionHighlight: 'mos-catalog-search-suggestion__container--highlight',
  sectionContainer: 'mos-catalog-search__section-container',
  sectionContainerFirst: 'mos-catalog-search__section-container--first',
  sectionTitle: 'mos-catalog-search__section-title',
};
